import React, { useEffect } from "react";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { Gallery } from "@/components/sections/Gallery";
import { QuoteCalculator } from "@/components/sections/QuoteCalculator";
import { About } from "@/components/sections/About";
import { Reviews } from "@/components/sections/Reviews";
import { Contact } from "@/components/sections/Contact";

export default function Home() {
  useEffect(() => {
    document.title =
      "Kilic Gebäudeservice Bremen | Professionelle Reinigung & Gartenpflege";
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <Services />
      <Gallery />
      <QuoteCalculator />
      <About />
      <Reviews />
      <Contact />
    </main>
  );
}
